import Link from 'next/link';
import { StructuredText } from 'react-datocms';

import Button from '@/components/common/Button/Button';
import type { RangeDescriptionSectionRecordModelType } from '@/models/api';

export type RangeDescriptionType = {
  section?: RangeDescriptionSectionRecordModelType;
  showButton?: boolean;
};

export const RangeDescription: React.FC<RangeDescriptionType> = ({
  section,
  showButton,
}) => {
  if (!section) return null;

  const { title, description, buttonText, titleBackgroundColor, buttonLink } =
    section;
  const bgColor = titleBackgroundColor?.hex || '#B88D3B';

  return (
    <div className="mb-3 flex w-full flex-col">
      <div
        className={`flex h-[38px] items-center rounded-t-md px-4 font-interBold text-white`}
        style={{ backgroundColor: bgColor }}
      >
        {title}
      </div>

      <div className="range-description rounded-b-md bg-off-grey px-8 pt-6">
        <StructuredText data={description} />

        <div className="mt-6 mb-8">
          {showButton && (
            <Link href={buttonLink || '/menu/meals'}>
              <Button theme="tertiary">
                <span>{buttonText}</span>
              </Button>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};
